import { convertPlayerPrice } from "@/functions/convertPlayerPrice";
import { cn } from "@/lib/utils";
import { eventTokensSelector } from "@/redux/loadedContent/loadedContentSlice";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { ObjectiveDisplay, PriceInfo } from "@repo/shared/types";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { usePriceDisplay } from "./usePriceDisplay";

interface PriceProps {
  size: "small" | "medium" | "large";
  priceInfo?: PriceInfo;
  objectiveDisplay?: ObjectiveDisplay;
}

const ICON_SIZE: Record<PriceProps["size"], string> = {
  small: "w-4 h-4 touch-device:w-4 touch-device:h-4",
  medium: "w-5 h-5 touch-device:w-5.5 touch-device:h-5.5",
  large: "w-5 h-5 touch-device:w-5.5 touch-device:h-5.5",
};

const LABEL_SIZE: Record<PriceProps["size"], string> = {
  small: "text-xs",
  medium: "text-sm",
  large: "text-base",
};

export const Price = ({ size, priceInfo, objectiveDisplay }: PriceProps) => {
  const { t } = useTranslation();
  const isSmallDesktop = useMediaQuery(BREAKPOINTS.SMALL_DESKTOP.query);
  const eventTokens = useSelector(eventTokensSelector);
  const { iconUrl, label, price, showPrice } = usePriceDisplay({
    priceInfo,
    objectiveDisplay,
    eventTokens,
    assetsBaseUrl: import.meta.env.VITE_APP_ASSETS_BASE_URL,
  });

  return (
    <div className="flex flex-row items-center gap-x-1">
      <div className="flex items-center gap-x-1">
        {iconUrl && (
          <img
            className={cn("shrink-0", ICON_SIZE[size])}
            src={iconUrl}
            alt={t("alt.coin")}
          />
        )}
      </div>
      {label && <div className={LABEL_SIZE[size]}>{label}</div>}
      {showPrice && (
        <div className={LABEL_SIZE[size]}>
          {convertPlayerPrice(price, isSmallDesktop)}
        </div>
      )}
    </div>
  );
};
